import React, { useEffect, useState } from "react";
import { useNavigate, NavLink } from "react-router-dom";
import { DashboardLayout, Pagination } from "../Components";
import { FaRegUserCircle } from "react-icons/fa";
import { BiArrowBack } from "react-icons/bi";
import axiosConfig from "../Service/axiosConfig";
import { MdOutlineMedicalInformation, MdListAlt, MdMeetingRoom, MdHistory } from "react-icons/md"
import { FaFileInvoice } from "react-icons/fa"
import sidebarData from "../Components/DashboardLayout/sidebar";
import DataTable from 'react-data-table-component';
import tableCustomStyles from "../Components/PopupModal/tableCustomStyles";
import { useParams } from "react-router-dom";

const PatientInvoices = () => {

    const navigate = useNavigate();
    const [loading, setLoading] = useState(false);
    const [patientData, setPatientData] = useState([])
    const [invoices, setInvoices] = useState([])
    const [ChildNavs, SetChildNavs] = useState("")
    const [Direction, setDirection] = useState("");
    const [Columns, setColumns] = useState("");
    const [totalRows, setTotalRows] = useState(0);
    const [currentPage, setCurrentPage] = useState(1);
    const [RowPerPage, setRowPerPage] = useState(20);
    const [patientDataFetched, setPatientDataFetched] = useState(false); 
    const [search, SetSearch] = useState({
        search: ""
    })
    const { uhid } = useParams();
    let patient_details;
    const patient_profile = [
        {
            "SubTitle": "Patient Profile",
            "NavItems": [
                { "label": "Info", "path": `/dashboard/patients/${uhid}/info`, "icon": <MdOutlineMedicalInformation fontSize='small' /> },
                { "label": "Invoices", "path": `/dashboard/patients/${uhid}/invoices`, "icon": <FaFileInvoice fontSize='small' /> },
                { "label": "Records", "path": `/dashboard/patients/${uhid}/records`, "icon": <MdListAlt fontSize='small' /> },
                { "label": "Appointments", "path": `/dashboard/patients/${uhid}/appointments`, "icon": <MdMeetingRoom fontSize='small' /> },
                { "label": "Visit History", "path": `/dashboard/patients/${uhid}/visit_history`, "icon": <MdHistory fontSize='small' /> },
            ]
        }
    ]

    const invoice_columns = [
        {
            name: 'Invoice ID',
            selector: 'invoice_id',
            cell: row => row.invoice_id,
            sortable: true,
        },
        {
            name: 'Invoice IDs',
            selector: 'invoice_ids',
            cell: row => row.invoice_ids,
            sortable: true,
        },
        {
            name: 'Bill',
            selector: 'bill',
            cell: row => row.bill,
            sortable: true,
        },
        {
            name: 'Total Amount',
            selector: 'total_amount',
            cell: row => row.total_amount,
            sortable: true,
        },
        {
            name: 'Discount',
            selector: 'discount',
            cell: row => row.discount,
            sortable: true,
        },
        {
            name: 'Net Amount',
            selector: 'net_amount',
            cell: row => row.net_amount,
            sortable: true,
        },
        {
            name: 'Bill ID',
            selector: 'bill_id',
            cell: row => row.bill_id,
            sortable: true,
        },
    ];

    const GetPatientData = async () => {
        setLoading(true)
        try {
            const responce = await axiosConfig.get(`/clinics/patient/?uhid=${uhid}`)
            setPatientData(responce.data.results)
            setPatientDataFetched(true)
            setLoading(false)
        }
        catch (error) {
            console.log(error)
        }
    }

    const GetInvoiceList = async () => {
        setLoading(true)
        try {
            const response = await axiosConfig.get(`/clinics/invoice/?bill=&bill__patient=${patientData[0].id}&page=${currentPage}&page_size=${RowPerPage}&ordering=${Direction === "asc" ? Columns : `-${Columns}`}`)
            setInvoices(response.data.results)
            console.log(response.data.results, "patient invoices")
            setTotalRows(response.data.count)
            setLoading(false)
        }
        catch (error) {
            console.log(error)
        }
    }

    const OnChildNavClicked = (path) => {
        SetChildNavs(path)
        localStorage.setItem("url", path)
    }

    const handleSort = (column, direction) => {
        setDirection(direction)
        setColumns(column.selector)
        setCurrentPage(1);
    };

    const HandleSearch = (e) => {
        e.preventDefault()
        const name = e.target.name
        const value = e.target.value
        axiosConfig.get(`clinics/invoice/?search=${value}`).then(res => {
            setInvoices(res.data.results)
        }).catch(error => {
            console.log(error)
        })
        SetSearch({ ...search, [name]: value })
    }

    useEffect(() => {
        GetPatientData()
        if (patientData) {
            GetInvoiceList();
        }
    }, [currentPage, RowPerPage, Columns, Direction,patientDataFetched])

    return (
        <DashboardLayout>
            <div className="mainbar">
                <div className="sidebar-filters px-3" style={{ height: "100vh" }}>
                    <button className="btn btn-primary mb-3" onClick={() => navigate(`/dashboard/patients/registration`)}><BiArrowBack />back to patients</button>
                    {
                        patient_profile.map((res, index) => {
                            return (
                                <div key={index}>
                                    <h5>{res.SubTitle}</h5>
                                    {
                                        res.NavItems.map((item, idx) => {
                                            return (
                                                <div key={idx} className={ChildNavs == item.path ? "Configiration-list active" : "Configiration-list"}>
                                                    <NavLink to={item.path} className={ChildNavs == item.path ? "colorChange" : "NoColorChange"} onClick={() => OnChildNavClicked(item.path)}>
                                                        <span className="configiration-icon">{item.icon}</span>
                                                        <span className="list-name">{item.label}</span>
                                                    </NavLink>
                                                </div>
                                            )
                                        })
                                    }
                                </div>
                            )
                        })
                    }
                </div>
                <div className="main-code">
                    <div className="dashboard-header">
                        <h5 className="dashboard-subtitle">Patient Invoices</h5>
                        <NavLink className="text-decoration-none" to="#"><button className="btn btn-primary d-inline">New Invoice</button></NavLink>
                    </div>
                    <DataTable
                        columns={invoice_columns}
                        data={invoices}
                        subHeader
                        fixedHeader
                        pagination paginationTotalRows={totalRows}
                        paginationPerPage={RowPerPage}
                        paginationDefaultPage={currentPage}
                        onChangePage={(page) => setCurrentPage(page)}
                        paginationPerPageOptions={[10, 20, 25, 30, 40, 50]}
                        paginationRowsPerPageOptions={[10, 20, 25, 30, 40, 50]}
                        onChangeRowsPerPage={(RowsPerPageChange) => setRowPerPage(RowsPerPageChange)}
                        onSort={handleSort}
                        paginationServer
                        subHeaderComponent={
                            <>
                                <input type="text" className="form-control w-25" name="search" value={search.search} onChange={HandleSearch} />
                            </>}
                        customStyles={tableCustomStyles}
                    />
                </div>
            </div>
        </DashboardLayout>
    )
}

export { PatientInvoices }